import { Component, OnInit, ViewChild, NgZone, Inject } from '@angular/core';
import { AuthService } from '../auth.service';
import { UserProvider } from '../user.service';
import { NgForm } from '@angular/forms';
import * as firebase from 'firebase/app';
import { MatDialogModule, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AngularFireStorage } from 'angularfire2/storage';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  @ViewChild('form') form: NgForm;
  @ViewChild('form2') form2: NgForm;

  successMessage: boolean = false;
  deleteMessage: boolean = false;
  failMessage: boolean = false;
  divTabelaCompleta: boolean = true;
  divTabelaPastaSelecionada: boolean = false;
  divTabelaCompletaBoleto: boolean = true;
  divTabelaPastaSelecionadaBoleto: boolean = false;
  editarCadastroUsuario: boolean = false;

  newuser = {
    email: '',
    password: '',
    displayName: '',
    nivel: ''
  }

  olduser = {
    displayName: '',
    nivel: ''
  }

  referencia;
  arquivo;
  boleto;
  dadosUser;

  listaUsuarios:any = {

  };
  listaDocUser = [];
  listaBoletoUser = [];
  listaPastaUser = [];
  listaPastaBoletosUser = [];
  listaDocsPastaSelecionada = [];
  listaUsuariosCadastrados = [];
  listaBoletoPastaSelecionada = [];
  listaDocsEnviadoUser = [];

  valorUsuario; //variável que armazena o ID do usuário idUsuário
  valorPasta; //variável que armazena o ID da pasta do Usuário
  valorPastaBoleto; //variável que armaneza o ID da pasta do Boleto
  nomePastaSelecionada;
  nomePastaBoletoSelecionada;
  nomeDocumento;
  nomeBoleto;
  adicionarDocumento: boolean = false; 

  valorIdDocumento;

  //upload
  selectedFiles: FileList;
  file: File;
  color: string = 'primary';
  mode: 'determinate';
  progressBarValue;
  progressBarValue2;
  uploadArquivo: String;
  uploadBoleto: String;

  constructor(
    public authService: AuthService,
    public userservice: UserProvider,
    public zone: NgZone,
    public dialog: MatDialog,
    private router: Router,
    private storage: AngularFireStorage
  ) {
    this.referencia = firebase.storage().ref();
    this.dadosUser = firebase.firestore().collection('users');  
   }

  ngOnInit() {
    this.userservice.consultaUsuarios().then((res: any) => {
      this.listaUsuarios = res;
    })

    this.userservice.consultaUsuariosCadastrados().then((res: any) => {
      this.listaUsuariosCadastrados = res;
      console.log(this.listaUsuariosCadastrados);
    })
  }

  onChange(SelectedValue){ 
    //populando variaveis que são usadas durante o código, ID do USUÁRIO e Setando o true para aparecer na tela
    this.adicionarDocumento = true;
    this.valorUsuario = SelectedValue; 
    this.divTabelaCompleta = true;
    this.divTabelaPastaSelecionada = false;

    //populando as pastas de documentos do usuário
    this.userservice.consultaPastaUser(SelectedValue).then((res: any) => {
      this.listaPastaUser = res;
    }) 
    
    //populando as pastas de boletos do usuário
    this.userservice.consultaPastaBoletosUser(SelectedValue).then((res: any) => {
      this.listaPastaBoletosUser = res;
    })   

    //populando os documentos do usuário selecionado
    this.userservice.consultarDocUser(SelectedValue).then((res: any) => {
      this.listaDocUser = res;
    })

    //populando os boletos do usuário selecionado
    this.userservice.consultarBoletoUser(SelectedValue).then((res: any) => {
      this.listaBoletoUser = res;
    })

    //populando os documentos enviados pelo usuário
    this.userservice.consultaDocsEnviadoUser(SelectedValue).then((res: any) => {
      this.listaDocsEnviadoUser = res;
    })
  }

  atualizaArquivo(event) {
    this.arquivo = event.target.files[0]; 
    this.uploadArquivo = "Novo Documento Selecionado";
    this.progressBarValue = 0;
  }

  atualizaBoletos(event) {
    this.boleto = event.target.files[0]; 
    this.uploadBoleto = "Novo Boleto Selecionado";
    this.progressBarValue2 = 0;
  }

  enviarArquivo(arquivo) {
    if(this.arquivo == null){
      this.failMessage = true;
      setTimeout(() => this.failMessage = false, 5000);
    }else{
      let caminho = this.referencia.child(this.valorUsuario+'/'+this.arquivo.name);
      const tarefa = caminho.put(this.arquivo);

      tarefa.on('state_changed', (snapshot)=>{
          this.progressBarValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          if(this.progressBarValue == 100){
            this.uploadArquivo = "Upload Realizado com sucesso";
          }
      }, error => {
         alert('Erro para transferir o arquivo!');
      }, () => {
        
         console.log(tarefa.snapshot.downloadURL);
         this.userservice.adicionarDocumentoUser(this.valorUsuario, this.nomeDocumento, tarefa.snapshot.downloadURL).then((res: any) => {
            this.form.reset();
            this.zone.run(() => {
              if(res.success){
                this.userservice.consultarDocUser(this.valorUsuario).then((res: any) => {
                  this.listaDocUser = res;
                })
              }else{
                console.log('ERRO');
              }    
            }) 

        })
      });
  }
 }

 enviarBoleto(boleto) {
  if(this.boleto == null){
    this.failMessage = true;
    setTimeout(() => this.failMessage = false, 5000);
  }else{
    let caminho = this.referencia.child(this.valorUsuario+'/'+'Boletos/'+this.boleto.name);
    const tarefaBoleto = caminho.put(this.boleto);

    tarefaBoleto.on('state_changed', (snapshot)=>{
        this.progressBarValue2 = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        if(this.progressBarValue2 == 100){
          this.uploadBoleto = "Upload Realizado com sucesso";
        }
    }, error => {
       alert('Erro para transferir o arquivo!');
    }, () => {
      
       console.log(tarefaBoleto.snapshot.downloadURL);
       this.userservice.adicionarBoletoUser(this.valorUsuario, this.nomeBoleto, tarefaBoleto.snapshot.downloadURL).then((res: any) => {
          this.form.reset();
          this.zone.run(() => {
            if(res.success){
              this.userservice.consultarBoletoUser(this.valorUsuario).then((res: any) => {
                this.listaBoletoUser = res;
              })
            }else{
              console.log('ERRO');
            }    
          }) 

      })
    });
}
} 

   adicionarPasta() {
    const dialogRef = this.dialog.open(DialogAddPasta, {
      data: {idDialogUser: this.valorUsuario}     
    });

    dialogRef.afterClosed().subscribe(result => {
      this.zone.run(() => {
        this.userservice.consultaPastaUser(this.valorUsuario).then((res: any) => {
          this.listaPastaUser = res;
        }) 
      })
    });
  }

  adicionarPastaBoletos() {
    const dialogRef = this.dialog.open(DialogAddPastaBoleto, {
      data: {idDialogUser: this.valorUsuario}     
    });

    dialogRef.afterClosed().subscribe(result => {
      this.zone.run(() => {
        this.userservice.consultaPastaBoletosUser(this.valorUsuario).then((res: any) => {
          this.listaPastaBoletosUser = res;
        }) 
      })
    });
  }

  pastaSelecionada(idPastaSelecionada){
    this.valorPasta = idPastaSelecionada;
    this.userservice.consultaNomePastaSelecionada(idPastaSelecionada, this.valorUsuario).then((res: any) => {
      this.nomePastaSelecionada = res.nomePasta;
    })
    this.userservice.consultaDocsPastaSelecionada(idPastaSelecionada, this.valorUsuario).then((res: any) => {
      this.listaDocsPastaSelecionada = res;
      this.divTabelaCompleta = false;
      this.divTabelaPastaSelecionada = true;
    })    
  }

  pastaBoletoSelecionada(idPastaSelecionada){
    this.valorPastaBoleto = idPastaSelecionada;
    this.userservice.consultaNomePastaBoletoSelecionada(idPastaSelecionada, this.valorUsuario).then((res: any) => {
      this.nomePastaBoletoSelecionada = res.nomePasta;
    })
    this.userservice.consultaDocsPastaBoletoSelecionada(idPastaSelecionada, this.valorUsuario).then((res: any) => {
      this.listaBoletoPastaSelecionada = res;
      this.divTabelaCompletaBoleto = false;
      this.divTabelaPastaSelecionadaBoleto = true;
    })
  }

  voltarDocumentosRaiz(){
    this.divTabelaCompleta = true;
    this.divTabelaPastaSelecionada = false;
  }

  voltarBoletoRaiz(){
    this.divTabelaCompletaBoleto = true;
    this.divTabelaPastaSelecionadaBoleto = false;
  }

  voltarEdicao(){
    this.editarCadastroUsuario = false;
  }

  arquivarDocumento(valorIdDocumento, content) {
    const dialogRef = this.dialog.open(DialogArquivar, {
      data: {
        idDialogUser: this.valorUsuario,
        idDialogDocUser: valorIdDocumento
      }
    });

    dialogRef.afterClosed().subscribe(result => { 
      if(result == true){
        this.successMessage = true;
        setTimeout(() => this.successMessage = false, 5000);
          this.zone.run(() => {
              this.userservice.consultarDocUser(this.valorUsuario).then((res: any) => {
                this.listaDocUser = res;
              }) 
          })
        }
    });
  }

  arquivarBoleto(valorIdBoleto, content) {
    const dialogRef = this.dialog.open(DialogArquivarBoleto, {
      data: {
        idDialogUser: this.valorUsuario,
        idDialogBoletoUser: valorIdBoleto
      }
    });

    dialogRef.afterClosed().subscribe(result => { 
      if(result == true){
        this.successMessage = true;
        setTimeout(() => this.successMessage = false, 5000);
          this.zone.run(() => {
              this.userservice.consultarBoletoUser(this.valorUsuario).then((res: any) => {
                this.listaBoletoUser = res;
              }) 
          })
        }
    });
  }

  removerDocumentoRaiz(valorIdDocumento) {
    const dialogRef = this.dialog.open(DialogDelete, {
      height: '200px'
      
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result == true){
        this.deleteMessage = true;
        setTimeout(() => this.deleteMessage = false, 5000);
        this.userservice.deletarDocUser(valorIdDocumento, this.valorUsuario).then((res: any) => {
          
          this.zone.run(() => {
              this.userservice.consultarDocUser(this.valorUsuario).then((res: any) => {
                this.listaDocUser = res;
              }) 
          })
        })
      }else{
      }
    });
  }

  removerDocumentoEnviadoUser(){
    //realizar consulta
  }

  removerBoletoRaiz(valorIdBoleto){
    const dialogRef = this.dialog.open(DialogDelete, {
      height: '200px'
      
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result == true){
        this.deleteMessage = true;
        setTimeout(() => this.deleteMessage = false, 5000);
        this.userservice.deletarBoletoUser(valorIdBoleto, this.valorUsuario).then((res: any) => {
          
          this.zone.run(() => {
              this.userservice.consultarBoletoUser(this.valorUsuario).then((res: any) => {
                this.listaBoletoUser = res;
              }) 
          })
        })
      }else{
      }
    });
  }

  removerDocumentoPastaSelecionada(valorIdDocumento) {
    const dialogRef = this.dialog.open(DialogDelete, {
      height: '200px'
      
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result == true){
        this.deleteMessage = true;
        setTimeout(() => this.deleteMessage = false, 4000);
        this.userservice.deletarDocPastaUser(this.valorUsuario, this.valorPasta, valorIdDocumento).then((res: any) => {
          
          this.zone.run(() => {
              this.userservice.consultaDocsPastaSelecionada(this.valorPasta, this.valorUsuario).then((res: any) => {
                this.listaDocsPastaSelecionada = res;
              }) 
          })
        })
      }else{
      }
    });
  }

  removerBoletoPastaSelecionada(valorIdBoleto) {
    const dialogRef = this.dialog.open(DialogDelete, {
      height: '200px'
      
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result == true){
        this.deleteMessage = true;
        setTimeout(() => this.deleteMessage = false, 5000);
        this.userservice.deletarBoletoPastaUser(this.valorUsuario, this.valorPastaBoleto, valorIdBoleto).then((res: any) => {
          
          this.zone.run(() => {
              this.userservice.consultaDocsPastaBoletoSelecionada(this.valorPastaBoleto, this.valorUsuario).then((res: any) => {
                this.listaBoletoPastaSelecionada = res;
              }) 
          })
        })
      }else{
      }
    });
  }

  signOut() {
    this.authService.logout();
  }

  signup() {
    if (this.newuser.email == '' || this.newuser.password == '' || this.newuser.displayName == '') {
      alert('Todos os campos são necessários');
    }
    else if (this.newuser.password.length < 7) {
      alert('Password fraca. Coloque mais de 6 caracteres, por favor');
    }
    else {
      this.authService.emailSignup(this.newuser).then((res: any) => {
        if (res.success){    
          alert('Usuário criado com sucesso!');
          this.form.reset();
        }
        else{
          alert('Error' + res);
        }
         
      })
    }
  } 

  //lista de usuários EDITAR e DELETAR

  abrirEditarUsuario(idUser){
    this.valorUsuario = idUser;
    this.userservice.consultaDadosUsuarioCadastrado(idUser)
      .then((res: any) => {
        console.log(res.displayName);
        this.olduser.displayName = res.displayName;
        this.olduser.nivel = res.nivel;
        this.editarCadastroUsuario = true;
      })
  }

  editarUsuario(){
    this.authService.editarUsuario(this.valorUsuario, this.olduser)
      .then((res: any) => {
        this.editarCadastroUsuario = false;
        this.zone.run(() => {
          this.userservice.consultaUsuariosCadastrados().then((res: any) => {
            this.listaUsuariosCadastrados = res;
          }) 
        })
      })
  }

  deletarUsuario(idUser){
    console.log(idUser);
    const dialogRef = this.dialog.open(DialogDelete, {
      height: '200px'
      
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result == true){
        this.successMessage = true;
        setTimeout(() => this.successMessage = false, 5000);
        this.userservice.deletarUsuario(idUser).then((res: any) => {
          this.zone.run(() => {
              this.userservice.consultaUsuariosCadastrados().then((res: any) => {
                this.listaUsuariosCadastrados = res;
              }) 
          })
        })
      }else{
      }
    });
  }
}




//Dialogs (modal para DELETAR, ARQUIVAR e ADICIONAR NOVAS PASTAS)
@Component({
  selector: 'dialog-delete',
  templateUrl: 'dialog-delete.html',
})
export class DialogDelete {
  constructor(
    public dialogRef: MatDialogRef<DialogDelete>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'dialog-arquivar',
  templateUrl: 'dialog-arquivar.html',
})
export class DialogArquivar {

  listaPastaUser = [];
  constructor(
    public dialogRef: MatDialogRef<DialogDelete>,
    public userservice: UserProvider,
    @Inject(MAT_DIALOG_DATA) public data) {}

    ngOnInit() {
      //populando as pastas do usuário
      this.userservice.consultaPastaUser(this.data.idDialogUser).then((res: any) => {
        this.listaPastaUser = res;
      })    
    }

    moverParaPasta(idPastaArquivo){
      this.userservice.arquivarDocUser(this.data.idDialogUser, idPastaArquivo, this.data.idDialogDocUser)
        .then((res: any) => {
          console.log('Arquivado com sucesso');
          this.dialogRef.close();
        })
    }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'dialog-arquivar-boleto',
  templateUrl: 'dialog-arquivar-boleto.html',
})
export class DialogArquivarBoleto {

  listaPastaBoletosUser = [];
  constructor(
    public dialogRef: MatDialogRef<DialogDelete>,
    public userservice: UserProvider,
    @Inject(MAT_DIALOG_DATA) public data) {}

    ngOnInit() {
      //populando as pastas do usuário
      this.userservice.consultaPastaBoletosUser(this.data.idDialogUser).then((res: any) => {
        this.listaPastaBoletosUser = res;
      })    
    }

    moverParaPasta(idPastaArquivo){
      this.userservice.arquivarBoletoUser(this.data.idDialogUser, idPastaArquivo, this.data.idDialogBoletoUser)
        .then((res: any) => {
          console.log('Arquivado com sucesso');
          this.dialogRef.close();
        })
    }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'dialog-addPasta',
  templateUrl: 'dialog-addPasta.html',
})
export class DialogAddPasta {
  @ViewChild('form') form: NgForm;
  nomePasta;
  
  constructor(
    public dialogRef: MatDialogRef<DialogDelete>,
    public userservice: UserProvider,
    @Inject(MAT_DIALOG_DATA) public data) {}

  onSubmit(form){
    if (form.valid) {
      var validaCriaPasta = 0;
      this.userservice.consultaPastaUser(this.data.idDialogUser)
      .then((res: any) => {
        for(var i=0;i<res.length;i++){
          if(res[i].nomePasta == form.value.nomePasta){
            validaCriaPasta = 1;
            alert('Já existe essa pasta para esse usuário, favor escolha outro nome de Pasta');
          }
        }
        if(validaCriaPasta == 0 ){
          this.userservice.adicionarPastaUser(this.data.idDialogUser, form.value.nomePasta)
          .then((res: any) => {
            console.log('Pasta criada com sucesso');
            this.dialogRef.close();
          })
          .catch((error: any) => {  
          });
        }

      }).catch((error: any) => {

      });
    }
  }

}

@Component({
  selector: 'dialog-addPastaBoleto',
  templateUrl: 'dialog-addPastaBoleto.html',
})
export class DialogAddPastaBoleto {
  @ViewChild('form') form: NgForm;
  nomePasta;
  
  constructor(
    public dialogRef: MatDialogRef<DialogDelete>,
    public userservice: UserProvider,
    @Inject(MAT_DIALOG_DATA) public data) {}

  onSubmit(form){
    if (form.valid) {
      var validaCriaPasta = 0;
      this.userservice.consultaPastaBoletosUser(this.data.idDialogUser)
      .then((res: any) => {
        for(var i=0;i<res.length;i++){
          if(res[i].nomePasta == form.value.nomePasta){
            validaCriaPasta = 1;
            alert('Já existe essa pasta para esse usuário, favor escolha outro nome de Pasta');
          }
        }
        if(validaCriaPasta == 0 ){
          this.userservice.adicionarPastaBoletosUser(this.data.idDialogUser, form.value.nomePasta)
          .then((res: any) => {
            console.log('Pasta criada com sucesso');
            this.dialogRef.close();
          })
          .catch((error: any) => {  
          });
        }

      }).catch((error: any) => {

      });
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/profile/profile.component.ts